import React from "react";
import BotonRegresar from "./shared/BotonRegresar";
const handleSubmit = (e) => {
  e.preventDefault();

  const nombre = document.getElementById("nombre_contacto").value;
  const correo = document.getElementById("email_contacto").value;
  const mensaje = document.getElementById("mensaje_contacto").value;

const mailtoLink = `mailto:fundacionsoffy@gmail.com,soffy.donavida@gmail.com?subject=Mensaje%20de%20${encodeURIComponent(
    nombre
  )}&body=Nombre:%20${encodeURIComponent(nombre)}%0ACorreo:%20${encodeURIComponent(
    correo
  )}%0AMensaje:%0A${encodeURIComponent(mensaje)}`;

  window.location.href = mailtoLink;
};

export default function Contacto({ onBack }) {

  
  return (
    <card className=" col l6 offset-l3">
      <div
        className="row z-depth-1"
        style={{
          borderRadius: "24px",
          overflow: "hidden",
          display: "flex",
          flexWrap: "wrap",
          backgroundColor: "#ffffff",
          boxShadow: "0 6px 12px rgba(0,0,0,0.05)",
        }}
      >
        <div
          className="col s12 m6"
          style={{
            backgroundColor: "#fce5ee",
            padding: "2.5rem",
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
          }}
        >
          <div>
            <h5
              style={{
                color: "#c11845",
                fontWeight: "600",
                marginBottom: "2rem",
              }}
            >
              💌 Información de contacto
            </h5>

            <div style={{ marginBottom: "2rem" }}>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  marginBottom: "1rem",
                }}
              >
                <div
                  style={{
                    backgroundColor: "#ef7cab",
                    borderRadius: "50%",
                    width: "40px",
                    height: "40px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    marginRight: "1rem",
                  }}
                >
                  <i className="material-icons white-text">email</i>
                </div>
                <span>
                  <strong>Email:</strong> fundacionsoffy@gmail.com
                </span>
              </div>

              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  marginBottom: "1rem",
                }}
              >
                <div
                  style={{
                    backgroundColor: "#ef7cab",
                    borderRadius: "50%",
                    width: "40px",
                    height: "40px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    marginRight: "1rem",
                  }}
                >
                  <i className="material-icons white-text">phone</i>
                </div>
                <span>
                  <strong>Tel:</strong> 442 243 0535
                  <br />
                  <strong>WhatsApp:</strong> 444 651 3754
                </span>
              </div>

              <div style={{ display: "flex", alignItems: "center" }}>
                <div
                  style={{
                    backgroundColor: "#ef7cab",
                    borderRadius: "50%",
                    width: "40px",
                    height: "40px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    marginRight: "1rem",
                  }}
                >
                  <i className="material-icons white-text">location_on</i>
                </div>
                <span>
                  Av. Calzada de Belén 537
                  <br />
                  Lomas de San Pedrito Peñuelas, Querétaro
                  <br />
                  C.P. 76148
                </span>
              </div>
            </div>
          </div>

          <div
            className="video-container"
            style={{
              borderRadius: "16px",
              overflow: "hidden",
              border: "2px solid #ef7cab",
            }}
          >
            <iframe
              title="Ubicación Fundación Soffy"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3734.1678409690484!2d-100.4041891!3d20.648347!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x85d35a4fc142e2b9%3A0xf310a124c1700fef!2sFundaci%C3%B3n%20Soffy%2C%20una%20mano%20amiga%20A.C.!5e0!3m2!1ses-419!2smx!4v1715622053933!5m2!1ses-419!2smx"
              width="100%"
              height="200"
              allowFullScreen=""
              loading="lazy"
              style={{ border: "none" }}
            ></iframe>
          </div>
        </div>

        <div
          className="col s12 m6"
          style={{ padding: "2.5rem", backgroundColor: "#ffffff" }}
        >
          <h5
            className="center-align"
            style={{ color: "#c11845", fontWeight: "600" }}
          >
            ✍️ Escríbenos un mensaje
          </h5>

<form className="row" onSubmit={handleSubmit} id="formulario-contacto" > 
            <div className="input-field col s12">
              <input id="nombre_contacto" type="text" className="validate" />
              <label htmlFor="nombre_contacto">Nombre completo</label>
            </div>

            <div className="input-field col s12">
              <input id="email_contacto" type="email" className="validate" />
              <label htmlFor="email_contacto">Correo electrónico</label>
            </div>

            <div className="input-field col s12">
              <textarea
                id="mensaje_contacto"
                className="materialize-textarea"
              ></textarea>
              <label htmlFor="mensaje_contacto">Mensaje</label>
            </div>

            <div className="input-field col s12 center-align">
              <button
                className="btn waves-effect waves-light pink-text"
                type="submit"
                style={{
                  backgroundColor: "white",
                  borderRadius: "30px",
                  padding: "0 2rem",
                  fontWeight: "600",
                }}
              >
                Enviar mensaje
              </button>
            </div>
          </form>
          <div className="input-field col s12 center-align">
            <BotonRegresar onClick={onBack} />
          </div>
        </div>
      </div>
    </card>
  );
}
